import { gql } from "@apollo/client";

import { GoalOverviewGoalFragment } from "./get-overview-goals-query";

export default gql`
  ${GoalOverviewGoalFragment}
  query getOverviewFavouriteGoalsQuery(
    $userId: Int!
    $goalDueBetweenDates: [Date]!
  ) {
    user(userId: $userId) {
      id
      favouriteArtifacts(
        artifactType: goal
        goalDueBetweenDates: $goalDueBetweenDates
        orderBy: "objective_alignment"
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        edges {
          node {
            id
            ... on GoalArtifactNode {
              ...GoalOverviewGoalFragment
            }
          }
        }
      }
    }
  }
`;
